import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { class: "manage-content" }
const _hoisted_3 = { class: "add-section" }
const _hoisted_4 = { class: "category-list" }
const _hoisted_5 = { class: "cat-name" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = {
  key: 0,
  style: {"text-align":"center","padding":"20px","color":"#999"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopupGrid = _resolveComponent("DxPopupGrid")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxDropDownOptions = _resolveComponent("DxDropDownOptions")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsAtribute,
      ref: "dataGridRef",
      "allow-column-reordering": false,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Id"
    }, {
      editTitle: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px 0 10px 20px","width":"100%"} }, " Editare Atribut ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: "Cauta ..."
        }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopupGrid, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 390,
              height: 390,
              "show-title": true,
              "title-template": "editTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, { "col-count": 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  "data-field": "AtributCategorieID",
                  "editor-type": "dxLookup",
                  "editor-options": { 
                        dataSource: _ctx.dsAtributeCategorii,
                        valueExpr: 'Id',     
                        displayExpr: 'Denumire',
                        height: 50
                    }
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "Cod",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Nume",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Tip",
                  "editor-type": "dxNumberBox",
                  "editor-options": _ctx.numberBoxTipOptions
                }, null, 8, ["editor-options"]),
                _createVNode(_component_DxItem, {
                  "data-field": "Initial",
                  "editor-options": { height: 50 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "order",
                  "editor-type": "dxNumberBox",
                  "editor-options": _ctx.numberBoxOrderOptions
                }, null, 8, ["editor-options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AtributCategorieID",
          visible: false,
          "allow-search": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Categorie",
          caption: "Categorie",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cod",
          caption: "Cod"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Nume",
          caption: "Nume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Tip",
          caption: "Tip"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Initial",
          caption: "Initial"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "order",
          caption: "Order"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, { location: "before" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { style: {"margin-right":"10px","font-weight":"bold"} }, "Categorie:", -1)),
                  _createVNode(_component_DxLookup, {
                    "data-source": _ctx.dsAtributeCategorii,
                    value: _ctx.filtru,
                    "value-expr": "Id",
                    "display-expr": "Denumire",
                    height: "40px",
                    onValueChanged: _ctx.onCategorieValueChanged
                  }, null, 8, ["data-source", "value", "onValueChanged"]),
                  _createVNode(_component_DxDropDownOptions, { "show-title": false })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, { location: "before" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "menu",
                  type: "default",
                  hint: "Gestionează Categorii",
                  onClick: _ctx.openManagePopup
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, {
              location: "after",
              name: "searchPanel"
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  hint: "Adaugă un atribut",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      width: "390",
      height: "390"
    }, {
      title: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare Atribut ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "data-dource": _ctx.newAtribut
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, { "data-field": "Categorie" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.categorie,
                  readOnly: true,
                  height: "50px"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Cod",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newAtribut.Cod,
                  onValueChanged: _ctx.onCodValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Nume",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newAtribut.Nume,
                  onValueChanged: _ctx.onNumeValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Tip" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxNumberBox, {
                  min: 0,
                  step: 1,
                  "show-spin-buttons": true,
                  "show-clear-button": true,
                  value: _ctx.newAtribut.Tip,
                  onValueChanged: _ctx.onTipValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Initial" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newAtribut.Initial,
                  onValueChanged: _ctx.onInitialValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Order" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxNumberBox, {
                  min: 0,
                  step: 1,
                  "show-spin-buttons": true,
                  "show-clear-button": true,
                  value: _ctx.newAtribut.order,
                  onValueChanged: _ctx.onOrderValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-dource"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.managePopupVisible,
      "show-title": true,
      width: "390",
      height: "390"
    }, {
      title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Gestionează Categorii ", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DxTextBox, {
              value: _ctx.newCategoryName,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newCategoryName) = $event)),
              placeholder: "Nume categorie nouă...",
              width: "100%",
              "value-change-event": 'input'
            }, null, 8, ["value"]),
            _createVNode(_component_DxButton, {
              icon: "add",
              type: "success",
              onClick: _ctx.onSaveNewCategory,
              "styling-mode": "contained",
              class: "circle-btn",
              disabled: !_ctx.newCategoryName
            }, null, 8, ["onClick", "disabled"])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "separator" }, null, -1)),
          _createVNode(_component_DxScrollView, { height: "100%" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localCategoriesList, (cat) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: cat.Id,
                    class: "category-row"
                  }, [
                    (_ctx.editingId !== cat.Id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(cat.Denumire), 1),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_DxButton, {
                              icon: "edit",
                              "styling-mode": "contained",
                              class: "circle-btn",
                              onClick: ($event: any) => (_ctx.startEdit(cat))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_DxButton, {
                              icon: "trash",
                              "styling-mode": "contained",
                              class: "circle-btn",
                              type: "danger",
                              onClick: ($event: any) => (_ctx.deleteCategory(cat.Id))
                            }, null, 8, ["onClick"])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_DxTextBox, {
                            value: _ctx.editingName,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingName) = $event)),
                            width: "100%"
                          }, null, 8, ["value"]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_DxButton, {
                              icon: "check",
                              type: "success",
                              "styling-mode": "contained",
                              class: "circle-btn",
                              onClick: ($event: any) => (_ctx.saveEdit(cat.Id))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_DxButton, {
                              icon: "close",
                              type: "danger",
                              "styling-mode": "contained",
                              class: "circle-btn",
                              onClick: _ctx.cancelEdit
                            }, null, 8, ["onClick"])
                          ])
                        ], 64))
                  ]))
                }), 128)),
                (_ctx.localCategoriesList.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Nu există categorii. "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_DxToolbarItem, {
          toolbar: "bottom",
          widget: "dxButton",
          location: "center",
          options: _ctx.closeManageOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}